<template>
    <div id="SMFTeam">
        <div class="container">
            <h1>{{ $t('team')}}</h1>

            <b-card-group deck style="margin-top:2rem; margin-bottom:2rem;">
                <b-card header-text-variant="primary"
                        title="Sylko Olzscher"
                        img-src="team-01c.jpg"
                        img-height="auto"
                        img-width="538px"
                        img-top
                        class="shadow">
                    <b-card-text class="text-muted">Inhaber | Projektmanagement</b-card-text>
                    <b-card-body>
                        <a href="mailto:sylko.olzscher@solostec.ch" title="sylko.olzscher@solostec.ch" class="card-link">{{ $t('email')}} &#128231;</a>
                        <p>Tel: +41 78 746 80 99</p>
                    </b-card-body>
                </b-card>

                <b-card header-text-variant="success"
                        title="Ayke Mauve"
                        img-src="team-02d.jpg"
                        img-top
                        class="shadow">
                    <b-card-text class="text-muted">Administration | Finanzen</b-card-text>
                    <b-card-body>
                        <a href="mailto:info@solostec.ch" title="info@solostec.ch" class="card-link">{{ $t('email')}} &#128231;</a>
                    </b-card-body>
                </b-card>

                <b-card header-text-variant="success"
                        title="Stefan Bleesz"
                        img-src="team-03c.jpg"
                        img-top
                        class="shadow">
                    <b-card-text class="text-muted">ICT Services | Projektmanagement</b-card-text>
                    <b-card-body>
                        <a href="mailto:info@solostec.ch" title="info@solostec.ch" class="card-link">{{ $t('email')}} &#128231;</a>
                    </b-card-body>
                </b-card>

            </b-card-group>

            <div style="margin-bottom:2rem;">
                <b-button v-b-toggle.imprint variant="primary">Impressum</b-button>
                <b-collapse id="imprint" class="mt-2">
                    <b-card title="solos::Tec" sub-title="Entwicklung, Beratung" class="shadow">
                        <b-card-text>
                            Hubelstrasse 16<br>
                            6012 Obernau<br>
                            Schweiz
                        </b-card-text>
                        <b-card-text>
                            Telefon: +41 78 746 80 99<br>
                            E-Mail: info@solostec.ch
                        </b-card-text>
                        <b-card-text>
                            IBAN: CH23 0024 8248 1094 2040 H<br>
                            UID: CHE-310.668.170
                        </b-card-text>
                    </b-card>
                </b-collapse>
            </div>

        </div>
    </div>
</template>

<script>

    export default {
        name: 'Team',
        data() {
            return {
                data: 'loading...'
            }
        }
    }
</script>

<style scoped lang="css">
        figure {
            margin: 2%;
        }

        aside {
            float: right;
            width: 20%;
            text-align: center;
        }

        .docscript-img {
            max-width: 95%;
            border: 2px solid #777;
        }

            .docscript-img:hover {
                box-shadow: 0 0 10px #ccc;
            }

        .docscript-footnote {
            margin-bottom: 0rem;
        }
        /* #SMFTeam {
      background: rgb(220,226,226);
    } */
</style>
